import React, { Component } from "react";
import { detailProduct } from "./data";
import axios from "axios";
// import { storeProducts, detailProduct } from './data';
// import { detailProduct } from 'https://04ce9cdf-8325-47de-a11e-04d9ccbaaed2.mock.pstmn.io/api/v1/project/17558/items/digital_content';
import Cookie, { eraseCookie, parseJwt } from "./components/store/Cookie";
import { methods } from './components/uikit-b2c/methods';


import { themes, styles } from "./defaults";




const ProductContext = React
  .createContext
  // {setPsToken: () => {}}
  ();
//Provider
//Consumer

class ProductProvider extends Component {
  constructor({ sections, psSections, userStyles, theme = { ...themes[0] } }) {
    super();

    this.psSections = psSections ? psSections : this.psSectionsDefault;
    this.styles = userStyles ? userStyles : styles;






    this.state = {
      // ps: { ...this.ps },

      user: null,

      sbShown: true,

      logToken: Cookie(),

      activeModule: "virtualItems",
      activeGroup: "first",

      sections: sections,
      psSections: this.psSections,
      psHandlers: this.psHandlers,


      loginShown: true,
      virtualItems: null,
      currency: null,
      subscriptions: null,

      // accountShown: true,

      merchantId: null,
      projectId: null,

      cartShown: false,
      cart: [],

      detailProduct: detailProduct, //TODO убрать
      psToken: "",

      theme: { ...this.styles, ...theme, },  //TODO: разобраться со стилями и темой  theme 5 -moon 4 -wes
      style: { ...this.styles },
    };
  }





  psSectionsDefault = {
    cart: {
      items: {
        itemType: {
          value:  "vi",
        },
        checkoutStyle: {
          value:  "button",
        },
        payment: {
          dependent: {
            value:  "button",
          },
          value:  false,
        },
        login: {
          value:  true,
        },
      },
    },
    method_card: {
      items: {
        cardVisual: {
          value: 'oldschool', //abstract
        }
      }
    }
  }










  psHandlers = {
    itemType: (nw) => {
      let newPS = { ...this.state['psSections'] };
      if (!newPS["cart"]["items"]["itemType"]) newPS["cart"]["items"]["itemType"] = {value:null}
      newPS["cart"]["items"]["itemType"]["value"] = nw;
      this.setStateFrom("psSections", newPS);
    },
    cartVar: (nw) => {
      let newPS = { ...this.state['psSections'] };
      if (!newPS["cart"]["items"]["cartVar"]) newPS["cart"]["items"]["cartVar"] = {value:null}
      newPS["cart"]["items"]["cartVar"]["value"] = nw;
      this.setStateFrom("psSections", newPS);
    },
    checkoutStyle: (nw) => {
      let newPS = { ...this.state['psSections'] };
      if (!newPS["cart"]["items"]["checkoutStyle"]) newPS["cart"]["items"]["checkoutStyle"] = {value:null}
      newPS["cart"]["items"]["checkoutStyle"]["value"] = nw;
      this.setStateFrom("psSections", newPS);
    },
    payment: () => {
      let newPS = { ...this.state['psSections'] };
      newPS["cart"]["items"]["payment"]["value"] = !newPS["cart"][
        "items"
      ]["payment"]["value"];
      this.setStateFrom("psSections", newPS);
    },
    login: () => {
      let newPS = { ...this.state['psSections'] };
      newPS["cart"]["items"]["login"]["value"] = !newPS["cart"]["items"][
        "login"
      ]["value"];
      this.setStateFrom("psSections", newPS);
    },
  }





  saveToLocal = (data) => {

    data = JSON.stringify(data)
    .replace('value:false,', 'defaultValue:false,')
    .replace('value:true,', 'defaultValue:true,');
    localStorage.setItem('xsollaBuilder', data);
  }

  changeTheme = (target = "global", newTheme, saveTheme = false) => {
    // let newColor = null;
    // if (typeof newTheme === 'string') {
    //   newColor = newTheme;
    //   this.setStateFrom(null, {
    //     ...this.state,
    //     theme:{
    //       ...this.state.theme,
    //       // colorBg: newColor
    //     }
    //   })
    // } else {
    //   this.setStateFrom(null, {
    //     ...this.state,
    //     theme: {
    //       ...this.state.theme,
    //       ...newTheme
    //     }
    //   }, ()=>{

    //   })
    // }

    if (typeof target === "undefined" || target === "global") {
      this.setStateFrom(null, {
        ...this.state,
        theme: {
          ...this.state.theme,
          ...newTheme,
        },
      });
    } else {
      let newSections = [...this.state["sections"]];
      newSections[target]["theme"] = newTheme;
      this.setStateFrom(null, {
        ...this.state,
        sections: newSections,
      });
    }
  };

  changeCardSize = (newSize) => {
    let newTheme = this.state.theme;
    newTheme["cardWidth"] = newSize;
    console.log("newSize = ", newSize);
    this.changeTheme(newTheme);
  };

  changeSections = (newSections) => {
    newSections.length &&
      this.setStateFrom(null, {
        sections: [...newSections],
      });
  };

  setPsToken = function(psToken) {
    this.setStateFrom(null, { psToken: psToken });
  }.bind(this);

  setProjectId = function(projectId) {
    this.setStateFrom(null, { projectId: projectId });
  }.bind(this);

  setMerchantId = function(merchantId) {
    this.setStateFrom(null, { merchantId: merchantId });
  }.bind(this);

  handleDetail = () => {
    console.log("hello from handleDetail");
  };

  setStateFrom = function(stateName, stateValue, save = true) {
    if (!stateName) {
      this.setState(
        {
          ...stateValue
        },
        () => {
          this.saveToLocal(this.state)
        });
    } else {

      this.setState(
        {
          [stateName]: stateValue,
        },
        () => {
          this.saveToLocal(this.state)
        }
        );
      }
  }.bind(this);

  addToCart = (product) => {
    debugger;
    this.state.cart
      ? this.setStateFrom(null, {
          cart: [...this.state.cart, product],
          cartShown: true,
        })
      : this.setStateFrom(null, {
          cart: [product],
        });
  };

  setGroups = function(virtualItems) {
    console.log("virtualItems ", virtualItems);
    this.setStateFrom(null, {
      virtualItems: virtualItems,
      fetching: false,
    });
  }.bind(this);

  getInfo = function(ind) {
    console.log("ind = ", ind);
    this.state["virtualItems"].map((oneGroup, indG) => {
      oneGroup["products"].map((oneProduct, indP) => {
        if (oneProduct.id === ind) {
          console.log("oneProduct = ", oneProduct);
          // oneProduct['is_favorite'] && console.log('oneProductFAV = ', oneProduct['is_favorite']);
          return oneProduct;
        }
      });
    });
  };

  calculateFavs = () => {};

  setViValue = function(
    id,
    setValue = (oneProduct) => {
      oneProduct.is_favorite = oneProduct.is_favorite === 1 ? 0 : 1;
      return oneProduct;
    }
  ) {
    let viCopy = {};
    viCopy = [...this.state["virtualItems"]];

    viCopy.map((oneGroup, indG) => {
      oneGroup["products"].map((oneProduct, indP) => {
        if (oneProduct.id === id) {
          oneProduct = setValue(oneProduct);
        }
      });
    });
    this.setStateFrom(null, {
      ...this.state,
      virtualItems: [...viCopy],
    });
  };

  setCurrs = function(resolvedData) {
    console.log("virtualItems", resolvedData["virtualItems"]);
    console.log("resolvedCurrency ", resolvedData["currency"]);
    console.log("resolvedSubscriptions ", resolvedData["subscriptions"]);
    this.setStateFrom(null, {
      fetching: false,
      virtualItems: resolvedData["virtualItems"],
      currency: resolvedData["currency"],
      subscriptions: resolvedData["subscriptions"],
    });
  }.bind(this);

  getTheme = (what = "all") => {
    if (what === "all") {
      return this.state.theme;
    }
    if (Object.keys(this.state.style).includes(what)) {
      return this.state.style[what];
    }
    return `${this.state.theme[what]}${what === "borderRadius" ? "px" : ""}`;
  };

  setProducts = function(storeProducts) {
    console.log("virtualItems ", storeProducts);
    this.setStateFrom(null, {
      storeProducts: storeProducts,
    });
  }.bind(this);

  componentWillUpdate(nextProps, nextState) {}




  getMethods = (methods, change) => {
    Object.keys(methods).forEach((oneMethId, ind) => {
      methods[oneMethId]["on"] = true;
    });
    return methods;
  };



  getPsConfigDefault = () => ({ //TODO: сделать стирание локал стораджа если новая версия!
    cart: {
      // component: <PSsectionCart ps={this.ps} handleSave={(nw) => this.setStateFrom('ps', nw)}/>,
      section: {
        title: "Cart",
        urls: ["/ps/cart"],
      },
      items: {
        itemType: {
          value:  this.state['psSections']['cart']['items']['itemType']['value'],
          controlType: "select",
          handle: this.state['psHandlers']['itemType'],
          options: [
            {
              title: "Virtual Items",
              value:  "vi",
            },
            {
              title: "Game",
              value:  "gamekey",
            },
            {
              title: "Virtual Currency",
              value:  "vc",
            },
            {
              title: "Subscription",
              value:  "subscription",
            },

            {
              title: "Several Games",
              value:  "gamekeys",
            },
          ],
        },
        methods: {
          value:  methods,
          value:  this.getMethods(methods),
        },
        checkoutStyle: {
          label: "Checkout style:",
          value:  this.state['psSections']['cart']['items']['checkoutStyle']['value'],
          controlType: "select",
          options: [
            {
              title: "Priority Payment methods",
              value:  "methods",
            },
            {
              title: "Pay now button",
              value:  "button",
            },
          ],
          handle: this.state['psHandlers']['checkoutStyle'],
        },
        payment: {
          dependent: {
            id: "checkoutStyle",
            value: 'methods',
          },
          label: "Monochrome",
          value: this.state['psSections']['cart']['items']['payment']['value'],
          controlType: "checkbox",
          handle: this.state['psHandlers']['payment'],
        },
        login: {
          label: "Login",
          value: this.state['psSections']['cart']['items']['login']['value'],
          controlType: "checkbox",
          handle: this.state['psHandlers']['login'],
        },
      },
    },
    choose: {
      section: {
        title: "Payment methods",
        urls: ["/ps/choose"],
      },
    },
    method_card: {
      section: {
        title: "Payment method",
        urls: [
          "/ps/method_card",
          "/ps/method_pp",
          "/ps/method_cvs",
          "/ps/method_apple",
          "/ps/method_cash",
          "/ps/method_installments",
        ],
      },
      method: 0,
      items: {
        cardVisual: {
          label: "Card style:",
          value:  this.state['psSections']['method_card']['items']['cardVisual']['value'],
          controlType: "select",
          options: [
            {
              title: "Old school card",
              value:  "oldschool",
            },
            {
              title: "Abstract",
              value:  "abstract",
            },
          ],
          handle: (nw) => {
            let newPS = { ...this.state['psSections'] };
            newPS["method_card"]["items"]["cardVisual"]["value"] = nw;
            this.state.setStateFrom("psSections", newPS);
          },
        },
        links: {
          controlType: "links",
          options: [
            {
              title: "Credit/Debit card",
              value:  "/ps/method_card",
            },
            {
              title: "Paypal",
              value:  "/ps/method_pp"
            },
            {
              title: "CSV",
              value:  "/ps/method_cvs"
            },
            {
              title: "Apple Pay",
              value:  "/ps/method_apple"
            },
            {
              title: "Cash",
              value:  "/ps/method_cash"
            },
            {
              title: "Installments",
              value:  "/ps/method_installments"
            },
          ],
        },
      },
    },
    status: {
      section: {
        title: "Status",
        urls: ["/ps/status"],
      },
      share: false,
      key: true,
      check: true,
    }
  })



  componentDidMount() {
    try { this.setState({psConfig: {...this.getPsConfigDefault}})} catch (e) {
      this.setState({psSections:this.psSectionsDefault})
      this.setState({psConfig:{...this.getPsConfigDefault}})
      debugger
    }



  }

  render() {
    // (this.state.storeProducts) && this.loadFromPS()

    return (
      <ProductContext.Provider
        value={{
          // products: this.state.products, //full
          ...this.state, //all props and vals
          psSections: this.state.psSections,
          psConfig: this.state.psConfig,
          psHandlers: this.psHandlers,
          handleDetail: this.handleDetail,
          setPsToken: this.setPsToken,
          projectId: this.state.projectId,
          setProjectId: this.setProjectId,
          merchantId: this.merchantId,
          setMerchantId: this.setMerchantId,
          setGroups: this.setGroups,
          setProducts: this.setProducts,
          setStateFrom: this.setStateFrom,
          setCurrs: this.setCurrs,
          addToCart: this.addToCart,
          getTheme: this.getTheme.bind(this),
          changeTheme: this.changeTheme,
          changeCardSize: this.changeCardSize,
          setViValue: this.setViValue.bind(this),
          getInfo: this.getInfo.bind(this),
        }}
      >
        {this.props.children}
      </ProductContext.Provider>
    );
  }
}

const ProductConsumer = ProductContext.Consumer;

export { ProductContext, ProductProvider, ProductConsumer };
